import axios from 'axios'
import Utils from '../services/Utils'

axios.defaults.timeout = 30000
axios.defaults.urls = JSON.parse(process.env.VUE_APP_URL)
axios.defaults.ptApiUrl = axios.defaults.urls[window.apiDev ? 'dev' : 'prod'][window.apiKey].base
Utils.updateAuthorization()

export default {
    getStrings(callback) {
        if (window.appCache && window.appCache.strings) {
            return Utils.processResponse(
                {
                    request: {
                        response: JSON.stringify({
                            success: true,
                            data: window.appCache.strings,
                        }),
                    },
                },
                callback,
            )
        }
        axios
            .get(axios.defaults.ptApiUrl + 'translations?website=1&lng=' + window.language, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: axios.defaults.authorization,
                },
            })
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    getEnums(callback) {
        if (window.appCache && window.appCache.enums) {
            Utils.refreshEnums(window.appCache.enums)
            return callback()
        }
        axios
            .get(axios.defaults.ptApiUrl + 'enums?pt_id=' + window.ptId + '&website=1&lng=' + window.language, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: axios.defaults.authorization,
                },
            })
            .then((response) => {
                let enums = {}
                if (response.data && response.data.data) {
                    enums = response.data.data
                }
                Utils.refreshEnums(enums)
                callback()
            })
            .catch(() => {
                Utils.refreshEnums({})
                callback()
            })
    },
    getRegisterConfig(callback) {
        if (window.appCache && window.appCache.registerConfig) {
            return Utils.processResponse(
                {
                    request: {
                        response: JSON.stringify({
                            success: true,
                            data: window.appCache.registerConfig,
                        }),
                    },
                },
                callback,
            )
        }
        axios
            .get(
                axios.defaults.ptApiUrl +
                    'register_config?db_id=' +
                    window.ptId +
                    (window.configType ? '&type=' + window.configType : '') +
                    (window.apiDev ? '&dev=1' : '') +
                    '&website=1&lng=' +
                    window.language,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.authorization,
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    register(data, callback) {
        data.pt_id = window.ptId

        axios
            .post(axios.defaults.ptApiUrl + 'register?website=1&lng=' + window.language, data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: axios.defaults.authorization,
                },
            })
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    newClientRegisterPhotos(data, callback) {
        axios
            .post(axios.defaults.ptApiUrl + 'register_photo?website=1&lng=' + window.language, data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: axios.defaults.authorization,
                },
            })
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    addSubscription(data, callback) {
        axios
            .post(
                axios.defaults.ptApiUrl +
                    'stripe_sub_create?db_id=' +
                    window.ptId +
                    (window.useCheckout ? '&checkout=1' : '') +
                    '&website=1&lng=' +
                    window.language,
                data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.authorization,
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    cancelSubscription(data, callback) {
        let url =
            'stripe_sub_cancel?paym_sub=' +
            data.paym_sub +
            '&db_id=' +
            window.ptId +
            (window.useCheckout ? '&checkout=1' : '') +
            (window.useHotmart ? '&hotmart=1' : '')
        if (window.useVivaWallet && data.paym_sub) {
            url = 'vw/subscription/cancel?pt_id=' + window.ptId + '&paym_sub=' + data.paym_sub
        }
        axios
            .post(
                axios.defaults.ptApiUrl + url + '&website=1&lng=' + window.language,
                {},
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.authorization,
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    registerInvalid(userId, callback) {
        axios
            .post(
                axios.defaults.ptApiUrl + 'register_invalid?id=' + userId + '&pt_id=' + window.ptId + '&website=1&lng=' + window.language,
                {},
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.authorization,
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    getUser(callback) {
        axios
            .get(
                axios.defaults.ptApiUrl +
                    'user?filter={"pt_id": ' +
                    window.ptId +
                    ',"id": ' +
                    window.clientId +
                    '}&photo=0&website=1&lng=' +
                    window.language,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.authorization,
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    getSubscriptionPlans(code, callback) {
        let codeFilter = ''
        if (code) {
            codeFilter = '&code=' + code
        }
        axios
            .get(
                axios.defaults.ptApiUrl +
                    'stripe_products?db_id=' +
                    window.ptId +
                    codeFilter +
                    (window.useCheckout ? '&checkout=1' : '') +
                    '&website=1&lng=' +
                    window.language,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.authorization,
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    getHotmartSubscriptionPlans(data, callback) {
        axios
            .get(
                axios.defaults.ptApiUrl +
                    'promo_code?db_id=' +
                    window.ptId +
                    '&filter={"code":"' +
                    data.code +
                    '"}&check_use=1&website=1&lng=' +
                    window.language,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.authorization,
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    sendRegisterPayment(data, callback) {
        axios
            .post(axios.defaults.ptApiUrl + 'register_payment?website=1&lng=' + window.language, data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: axios.defaults.authorization,
                },
            })
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    sendPayment(data, callback) {
        axios
            .post(axios.defaults.ptApiUrl + 'payment?db_id=' + data.id + '&website=1&lng=' + window.language, data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: axios.defaults.authorization,
                },
            })
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    updateUser(data, callback) {
        axios
            .patch(
                axios.defaults.ptApiUrl + 'user?id=' + window.clientId + '&pt_id=' + window.ptId + '&website=1&lng=' + window.language,
                data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.authorization,
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    createOrderVW(data, callback) {
        let id = null
        if (data && data.id) {
            id = data.id
            data = {}
        }
        axios
            .post(
                axios.defaults.ptApiUrl +
                    'vw/order/create?pt_id=' +
                    window.ptId +
                    (id ? '&id=' + id : '') +
                    '&website=1&lng=' +
                    window.language,
                data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.authorization,
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    getSubscriptionVW(callback) {
        axios
            .get(
                axios.defaults.ptApiUrl +
                    'vw/subscription/info?id=' +
                    window.clientId +
                    '&pt_id=' +
                    window.ptId +
                    '&website=1&lng=' +
                    window.language,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.authorization,
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    getPacks(data, callback) {
        axios
            .get(
                axios.defaults.ptApiUrl +
                    'pack?db_id=' +
                    window.ptId +
                    (!data.category && !data.code && !window.useHotmart && !data.ignore_user_id && !window.bookingScheduleId
                        ? '&user_id=' + window.clientId
                        : '') +
                    '&query=[{"f":"status","q":0,"v":0,"n":1},' +
                    (data.category || data.category === 0 ? '{"f":"category","q":0,"v":' + data.category + ',"n":1},' : '') +
                    (data.gateway ? '{"f":"gateway","q":0,"v":' + data.gateway + ',"n":1},' : '') +
                    '{"f":"start_date","d":1,"q":4,"v":"\'now\'","x":1,"n":1},{"f":"end_date","d":1,"q":5,"v":"\'now\'","x":1,"n":0}]' +
                    (data.code ? '&promo_code=' + data.code : '') +
                    '&website=1&lng=' +
                    window.language,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.authorization,
                    },
                },
            )
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    newBooking(data, callback) {
        data.pt_id = window.ptId
        data.client_id = window.clientId
        axios
            .post(axios.defaults.ptApiUrl + 'booking?website=1&lng=' + window.language, data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: axios.defaults.authorization,
                },
            })
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    login(data, callback) {
        Utils.updateAuthorization(data)
        axios
            .post(axios.defaults.ptApiUrl + 'login?pt_id=' + window.ptId + '&lng=' + window.language, data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: axios.defaults.authorization,
                },
            })
            .then((response) => {
                Utils.processResponse(response, callback)
            })
            .catch((response) => {
                Utils.processResponse(response, callback)
            })
    },
    async createOrderEuPago(data, callback) {
        const getAuthorization = async () => {
            try {
                const eupagoLoginData = JSON.parse(process.env.VUE_APP_EUPAGO)
                const authorizationPayload = eupagoLoginData ? eupagoLoginData[window.ptId.toString()] : null
                if (authorizationPayload) {
                    const res = await axios.post('https://api.mkgest.services/v1/token/', authorizationPayload, {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })
                    if (res.data && res.data.access) {
                        return `Bearer ${res.data.access}`
                    }
                }
            } catch {}
            return null
        }
        const authorization = await getAuthorization()
        axios
            .post('https://api.mkgest.services/v1/eupago/cofidis-external/', data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: authorization,
                },
            })
            .then((response) => {
                callback({
                    success: true,
                    data: response.data,
                })
            })
            .catch((response) => {
                callback({
                    success: false,
                    data: null,
                    message:
                        response && response.response && response.response.data && response.response.data.message
                            ? response.response.data.message
                            : window.strings['common_error'],
                })
            })
    },
    createOrderSequra(data, authorization, callback) {
        const authenticationError = window.strings['sequra_authentication_error'] || window.strings['common_error']
        if (!authorization) {
            return callback({
                success: false,
                data: null,
                message: authenticationError,
            })
        }
        axios
            .post('https://api.mkgest.services/v1/sequra/external/create/', data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: authorization,
                },
            })
            .then((response) => {
                callback({
                    success: response && response.data && response.data.status === 'success' ? true : false,
                    data: response && response.data ? response.data : null,
                    message: response && response.data && response.data.message ? response.data.message : window.strings['common_error'],
                })
            })
            .catch((error) => {
                callback({
                    success: false,
                    data: null,
                    message: error && error.response && error.response.data && error.response.data.message ? error.response.data.message : window.strings['common_error'],
                })
            })
    },
}
